export const REA = 'RealEstateAgent'
export const LO = 'LoanOfficer'
